import DTO from './DTO';

class TransportDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'brand',
        type: String,
        validators: {},
        labelKey: 'transport.brand',
      },
      {
        name: 'model',
        type: String,
        validators: {},
        labelKey: 'transport.model',
      },
      {
        name: 'color',
        type: String,
        validators: {},
        labelKey: 'transport.color',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default TransportDTO;
